import HttpClient from "./HttpClient";

export default class StatusName {
    constructor(statusName) {
        this.id = statusName.id;
        this.status = statusName.status;
        this.text = statusName.text;
        this.language = statusName.language;
        this.table_name =statusName.table_name;
        this.created_at = statusName.created_at;
        this.updated_at = statusName.updated_at;
        this.value = statusName.status;
    }

    static getStatusNames(statusNames, table_name)
    {
        const statusNamesObj = [];
        for(const statusName of statusNames){
            if(statusName.table_name == table_name){
                statusNamesObj.push(new StatusName(statusName));
            }
        }
        return statusNamesObj;
    }

    static async loadStatusNames(data){
        const client = new HttpClient();
        const response = await client.instance.get("statuses", data);
        return response.data;
    }
}